import React, { memo } from 'react'
import Header from './Header'
import ContentRoutes from './ContentRoutes'
import { useSelector } from 'react-redux'

function Content() {
  let user_device = useSelector((state) => state?.deviceReducer?.device)
  return (
    <div
      className={`flex flex-col w-full dark:bg-slate-900 ${
        user_device === 'desktop' ? 'mr-56' : 'mr-0 mb-16'
      }`}
    >
      <Header />
      <ContentRoutes />
    </div>
  )
}

export default memo(Content)
